// extracted by mini-css-extract-plugin
export default {"wrapper":"HowItWorks_wrapper__95HZu","payoutPool":"HowItWorks_payoutPool__5PIKv","infoText":"HowItWorks_infoText__CJwIK","infoList":"HowItWorks_infoList__zuAZI"};